import { Component, Input, OnInit } from '@angular/core';
import { FileHandlerActionEnum, IFileHandlerAction, IFileHandlerExcludeImageFromLicense, IFileHandlerPublishAsOerAction, IFileHandlerReplaceImageAction } from 'src/classes/file-handler.abstract';
import { IImageWrapper } from 'src/models/image-wrapper';
import { SessionServiceService } from '../services/session-service.service';
import { LoggerService } from "../services/logger/logger.service";
import { UI_ACTION_CONSTANTS } from '../services/logger/constants';
import { Router } from '@angular/router';
import { ModuleTrackerService } from '../services/module-tracker.service';

export type ActionElement = {type: string, imgFrom: IImageWrapper, imgTo?: IImageWrapper, text: string, indexInActionQueue: number, details?: string};

@Component({
  selector: 'app-action-viewer',
  templateUrl: './action-viewer.component.html',
  styleUrls: ['./action-viewer.component.scss']
})


export class ActionViewerComponent implements OnInit {

  // @Input('actionQueue')
  // set actionQueue(actionQueue: IFileHandlerAction[]){
  //   this.allActions = this.processActionsQueue(actionQueue)
  // }

  public allActions : ActionElement[] = [];
  constructor(
    private session: SessionServiceService, 
    private _logger: LoggerService,
    private router: Router,
    private moduleTracker: ModuleTrackerService
  ) {}

  ngOnInit(): void {
    this.allActions = this.processActionsQueue(this.session.getFileHandler().getActionQueue())
  }

  processActionsQueue(actionQueue: IFileHandlerAction[] ){
    const allActions : ActionElement[] = [];
    for (let i = 0; i < actionQueue.length; i++) {
      const actionEl = actionQueue[i];
      switch (actionEl.action) {
        case FileHandlerActionEnum.REPLACE_IMAGE_BY_URL: {
          const el = actionEl as IFileHandlerReplaceImageAction;
          allActions.push({type: el.action, text: $localize `Replace Image`, imgFrom: el.toReplace, imgTo: el.replacingBy, indexInActionQueue: i })
          break;
        }
        case FileHandlerActionEnum.REPLACE_IMAGE_BY_BASE64: {
          const el = actionEl as IFileHandlerReplaceImageAction;
          allActions.push({type: el.action, text: $localize `Replace Image`, imgFrom: el.toReplace, imgTo: el.replacingBy, indexInActionQueue: i })

          break;
        }
        case FileHandlerActionEnum.ADD_SOURCE_CREDITS:

          console.log(`Tried to get ADD_SOURCE_CREDITS action: ${actionEl}`);
          break;
        case FileHandlerActionEnum.PUBLISH_AS_OER: {
          const el = actionEl as IFileHandlerPublishAsOerAction;
          allActions.push({type: el.action, text: $localize `Publish Image as OER`, imgFrom: el.image, indexInActionQueue: i })
          break;
        }
        case FileHandlerActionEnum.EXCLUDE_FROM_LICENSE: {
          const el = actionEl as IFileHandlerExcludeImageFromLicense;
          allActions.push({type: el.action, text: (($localize `Exclude Image from License`) + (el.withoutNotice ? $localize ` (without notice)` : '')), imgFrom: el.toExclude, indexInActionQueue: i, details: el.noticeText})
          break;
        }
        default:
          console.log(`Tried to get unknown action: ${actionEl}`);
          break;
      }
    }
    return allActions;
  }

  deleteAction(action: ActionElement, index: number){
    const images = this.session.getImages();
    images.unshift(action.imgFrom);
    this.session.setImages(images);
    this.session.nextImagesFromFile(this.session.getImages());

    // log undo action finished ui action
    this._logger.log(UI_ACTION_CONSTANTS.REPLACED_IMAGE_UNDID, {
      sourceImage: action.imgFrom.source
    });

    const actionQueue = this.session.getFileHandler().getActionQueue();
    actionQueue.splice(action.indexInActionQueue,1);
    this.session.getFileHandler().setActionQueue(actionQueue);
    this.allActions = this.processActionsQueue(this.session.getFileHandler().getActionQueue())
  }

  /**
   * Navigate back to the unprocessed images in the current module
   */
  goBackToUnprocessed(): void {
    const unprocessedSection = document.getElementById('images-from-file-container');
    if (unprocessedSection) {
      unprocessedSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
